import { Link } from "react-router";
import { educationProjects } from "~/src/data/educationProjects";
import { workProjects } from "~/src/data/workProjects";
import * as styles from "./SelectedProjects.module.css";

const projectsInfoArray = [...workProjects, ...educationProjects];
let selectedProjects = [];

for (const project of projectsInfoArray) {
  const namesOfSelectedProjects = [
    "Web Dev Path",
    "Postss",
    "React Image Grid Gallery",
    "Conventional Changelog",
    "Pantry Picker",
  ];
  if (namesOfSelectedProjects.includes(project.name)) {
    selectedProjects.push(project);
  }
}

const selectedProjectCards = selectedProjects.map((i) => {
  return (
    <div key={crypto.randomUUID()} className={`${styles.card} card-container`}>
      <span className={styles.infoSpan}>
        <Link to={i.github} target="_blank" rel="noopener">
          <h3>{i.name}</h3>
          <p>{i.about}</p>
        </Link>
        <span className={styles.techStack}>
          <strong>Tech Stack: </strong>
          {i.stack}
        </span>
      </span>
      <span className={`${styles.imageContainer} proj-img-container`}>
        <Link to={i.link} target="_blank" rel="noopener">
          <img src={i.imgSrc} alt={i.imgAlt} placeholder="blur" />
        </Link>
      </span>
    </div>
  );
});

export default function SelectedProjects() {
  return (
    <section className={styles.projectSection}>
      <h2 id="projects" className={styles.heading}>
        Featured Projects
      </h2>
      {selectedProjectCards}
    </section>
  );
}
